import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const TagContainer = styled(Box)`
  padding: 4px 8px;
`
